import LinkifiedTextRenderer from './LinkifiedTextRenderer';

export default LinkifiedTextRenderer;
